const BranchDCBReportActionTypes = {
	/** ***************** GET BRANCH DCB REPORT START *********************** */
	GET_BRANCH_DCB_REPORT_LIST_START: 'GET_BRANCH_DCB_REPORT_LIST_START',
	GET_BRANCH_DCB_REPORT_LIST_SUCCESS: 'GET_BRANCH_DCB_REPORT_LIST_SUCCESS',
	GET_BRANCH_DCB_REPORT_LIST_FAILURE: 'GET_BRANCH_DCB_REPORT_LIST_FAILURE',
	GET_BRANCH_DCB_REPORT_LIST_RESPONSE_RESET: 'GET_BRANCH_DCB_REPORT_LIST_RESPONSE_RESET',
	GET_BRANCH_DCB_REPORT_LIST_RESPONSE_CHANGED: 'GET_BRANCH_DCB_REPORT_LIST_RESPONSE_CHANGED',
	/** ***************** GET BRANCH DCB REPORT END *********************** */
};
export default BranchDCBReportActionTypes;
